<template>
  <v-app-bar app clipped-right dense color="secondary" dark height="70" elevation="0">

    <!-- SHOW / HIDE SIDE-BAR BTN -->
    <v-app-bar-nav-icon @click.stop="drawer = !drawer; $emit('update-drawer', drawer)" />

    <!-- APP-BAR TITLE -->
    <v-toolbar-title class="py-5 align-center">
      <span class="title">لوحة التحكم</span>
    </v-toolbar-title>

    <v-spacer />

    <v-btn
      class="ml-4"
      icon
      :color="`grey ${fluid ? 'lighten-2' : 'lighten-1'}`"
      @click="fluid = !fluid; $emit('update-container', fluid)"
    >
      <v-icon>mdi-arrow-expand-horizontal</v-icon>
    </v-btn>

    <!-- AUTHENTICATED ADMIN MENU -->
    <v-menu offset-y rounded="0">
      <template v-slot:activator="{ on, attrs }">
        <v-btn elevation="0" color="grey lighten-3" class="rounded-0" v-bind="attrs" v-on="on">
          <v-icon color="secondary">mdi-account-details</v-icon>
        </v-btn>
      </template>

      <v-list class="rounded-0">
        <v-list-item @click="SET_RECORD_FORM($auth.user()); SET_EDIT_MODE(true); SHOW_RECORD_FORM()">
          <v-list-item-title>تعديل بياناتي</v-list-item-title>
        </v-list-item>
        <v-list-item @click="$auth.logout({ redirect: '/login' })">
          <v-list-item-title>خروج</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- CREATE / UPDATE ADMIN FROM -->
    <admin-record-form @update="fetchRecords({})" />
  </v-app-bar>
</template>


<script>
import { mapState, mapMutations } from "vuex";
import AdminRecordForm from '@/views/admins/RecordForm';

export default {
  name: "app-bar",
  components: { AdminRecordForm },

  data: function() {
    return {
      drawer: true,
      fluid: false
    };
  },


  methods: {
    ...mapMutations("admins", [
      "SHOW_RECORD_FORM",
      "SET_EDIT_MODE",
      "SET_RECORD_FORM",
    ]),
  },
};
</script>